import { useObservable } from "micro-observables";
import React from "react";
import styled from "styled-components";
import { ImageSection } from "@domain/lms/course/courseSection";
import { getAssetById } from "@domain/lms/course/utils";
import { ImageVersions } from "@domain/media/dtos";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { useEditorController } from "@ui/pages/lms/courseEditorPage/courseEditorController/editorControllerContext";

interface ImageSectionEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	section: ImageSection;
	collapsed?: boolean;
	onExtend?: () => void;
}
export const ImageSectionEditor: React.FC<ImageSectionEditorProps> = ({
	section,
	collapsed = false,
	onExtend,
	...htmlProps
}) => {
	const courseController = useEditorController();
	const observableCourse = useObservable(courseController.course);
	const asset = getAssetById(observableCourse.content, section.assetId);

	if (!asset) {
		return null;
	}
	if (collapsed) {
		return (
			<CollapsedContainer {...htmlProps} onClick={() => onExtend && onExtend()}>
				<span>
					<b>{asset.mimeType}</b>
					{" - " + asset.url}
				</span>
			</CollapsedContainer>
		);
	}
	return (
		<Container {...htmlProps}>
			<img src={asset?.versions ? asset.versions[ImageVersions.MEDIUM] : asset.url} />
		</Container>
	);
};

const CollapsedContainer = styled(RoundedBlock)`
	cursor: pointer;
	position: relative;
	padding: 10px 32px 10px 16px;
	margin: -10px -16px;
	overflow: hidden;

	span {
		font-size: 0.75rem;
		max-height: 30px;
		align-self: flex-start;
	}

	@media (max-width: 900px) {
		span {
			display: block;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
`;

const Container = styled.div`
	overflow: hidden;
	background-color: ${({ theme }) => theme.colors.white};
	border-radius: 10px;
	margin: -10px -46px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;

	img {
		width: auto;
		max-width: 100%;
		max-height: 400px;
	}

	@media (max-width: 900px) {
		margin: -10px -16px;
	}
`;
